import React, { useContext } from 'react';
import { BmsContext } from '../../../../App';

const ActiveBalance = () => {
    const { liveBMSData } = useContext(BmsContext);

    const F0 = liveBMSData?.bmsData?.F0;
    const F1 = liveBMSData?.bmsData?.F1;
    const E2 = liveBMSData?.bmsData?.E2;
    const E4 = liveBMSData?.bmsData?.E4;
    const E5 = liveBMSData?.bmsData?.E5;

    // Getting battery Type 
    let batteryType;
    if (E4) {
        if (E4.batteryType === '0') {
            batteryType = "Lithium Iron Phosphate";
        }
        else if (E4.batteryType === '1') {
            batteryType = "Ternary";
        }
        else if (E4.batteryType === '2') {
            batteryType = "Ternary Titanate";
        }
    }

    // getting specialChargeSwitch state 
    let specialChargeSwitch;
    if (E5) {
        if (E5.specialChargeSwitch === "0") {
            specialChargeSwitch = "Off";
        }
        else if (E5.specialChargeSwitch === "1") {
            specialChargeSwitch = "On";
        }
    }

    return (
        <div class="overflow-x-auto mt-3 mb-5">
            {liveBMSData && <table class="table table-compact w-full">
                <thead className='text-white'>
                    <tr>
                        <th className='bg-primary text-xs md:text-base'>Project</th>
                        <th className='bg-primary text-xs md:text-base'>Machine</th>
                        <th className='bg-primary text-xs md:text-base'>Setting</th>
                        <th className='bg-primary text-xs md:text-base'>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {/* row 1 ------------------------------------------------------------------------------ */}
                    <tr>
                        <td className='w-48 md:w-80'><h3 className='md:text-base font-medium whitespace-normal'>No. Of Battery String</h3></td>
                        <td>
                            <div class="badge bg-blue-50 text-primary border-blue-400 px-2 gap-2 md:text-base font-medium">
                                {F1?.batteryStringNo}
                            </div>
                        </td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/* --------------------------------------------------------------------------------------- */}

                    {/* row 2 ------------------------------------------------------------------------------ */}
                    <tr>
                        <td className='w-48 md:w-80'><h3 className='md:text-base font-medium whitespace-normal'>No. Of Temperature</h3></td>
                        <td>
                            <div class="badge bg-orange-50 text-accent border-orange-400 px-2 gap-2 md:text-base font-medium">
                                {F1?.tempNo}
                            </div>
                        </td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/* --------------------------------------------------------------------------------------- */}

                    {/* row 3 ------------------------------------------------------------------------------ */}
                    <tr>
                        <td className='w-48 md:w-80'><h3 className='md:text-base font-medium whitespace-normal'>Battery Type</h3></td>
                        <td>
                            <div class="badge bg-green-50 text-black border-green-400 pb-1 px-2 gap-2 md:text-base font-medium">
                                {batteryType}
                            </div>
                        </td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/* --------------------------------------------------------------------------------------- */}

                    {/* row 4 ------------------------------------------------------------------------------ */}
                    <tr>
                        <td className='w-48 md:w-80'><h3 className='md:text-base font-medium whitespace-normal'>Balance Current</h3></td>
                        <td><h3 className='md:text-base font-medium'>{F0?.soc} A</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/* --------------------------------------------------------------------------------------- */}

                    {/* row 5 ------------------------------------------------------------------------------ */}
                    <tr>
                        <td className='w-48 md:w-80'><h3 className='md:text-base font-medium whitespace-normal'>Cell Reference Voltage</h3></td>
                        <td><h3 className='md:text-base font-medium'>{F0?.volt} V</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/* --------------------------------------------------------------------------------------- */}

                    {/* row 6 ------------------------------------------------------------------------------ */}
                    <tr>
                        <td className='w-48 md:w-80'><h3 className='md:text-base font-medium whitespace-normal'>Battery Capacity Setting</h3></td>
                        <td><h3 className='md:text-base font-medium'>{E4?.betterCapacitySetting}</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/* --------------------------------------------------------------------------------------- */}

                    {/* row 7 ------------------------------------------------------------------------------ */}
                    <tr>
                        <td className='w-48 md:w-80'><h3 className='md:text-base font-medium whitespace-normal'>Actual Battery Capacity</h3></td>
                        <td><h3 className='md:text-base font-medium'>{E4?.actualBatteryCapacity
                        } AH</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/* --------------------------------------------------------------------------------------- */}

                    {/* row 8 ------------------------------------------------------------------------------ */}
                    <tr>
                        <td className='w-48 md:w-80'><h3 className='md:text-base font-medium whitespace-normal'>Dormancy Waiting Time</h3></td>
                        <td><h3 className='md:text-base font-medium'>{E5?.dormancyWaitingTime
                        } AH</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/* --------------------------------------------------------------------------------------- */}

                    {/* row 9 ------------------------------------------------------------------------------ */}
                    <tr>
                        <td className='w-48 md:w-80'><h3 className='md:text-base font-medium whitespace-normal'>Special Charge Switch</h3></td>
                        <td><h3 className='md:text-base font-medium'>{specialChargeSwitch}</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/* --------------------------------------------------------------------------------------- */}

                    {/* row 10 ------------------------------------------------------------------------------ */}
                    <tr>
                        <td className='w-48 md:w-80'><h3 className='md:text-base font-medium whitespace-normal'>Current Calibration</h3></td>
                        <td><h3 className='md:text-base font-medium'>{E5.currentCalibration
                        }</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/* --------------------------------------------------------------------------------------- */}

                    {/* row 11 ------------------------------------------------------------------------------ */}
                    <tr>
                        <td className='w-48 md:w-80'><h3 className='md:text-base font-medium whitespace-normal'>Low Capacity Alarm</h3></td>
                        <td><h3 className='md:text-base font-medium'>{E5.lowCapacityAlarm
                        }</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/* --------------------------------------------------------------------------------------- */}

                    {/* row 12 ------------------------------------------------------------------------------ */}
                    <tr>
                        <td className='w-48 md:w-80'><h3 className='md:text-base font-medium whitespace-normal'>Equalizing Start Volt</h3></td>
                        <td><h3 className='md:text-base font-medium'>{E2.equalizingStartVolt
                        } V</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/* --------------------------------------------------------------------------------------- */}

                    {/* row 13 ------------------------------------------------------------------------------ */}
                    <tr>
                        <td className='w-48 md:w-80'><h3 className='md:text-base font-medium whitespace-normal'>Opening Differential Pressure</h3></td>
                        <td><h3 className='md:text-base font-medium'>{E2.openingDiffentialPressure
                        } V</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/* --------------------------------------------------------------------------------------- */}

                    {/* row 14 ------------------------------------------------------------------------------ */}
                    <tr>
                        <td className='w-48 md:w-80'><h3 className='md:text-base font-medium whitespace-normal'>Equalizing Switch</h3></td>
                        <td><h3 className='md:text-base font-medium'>{E2.equalizingSwitch
                        }</h3></td>
                        <td className='w-48 md:w-64'>
                            <input type="text" placeholder="Type here" className="input input-xs md:input-sm input-bordered input-primary w-full mr-3" />
                        </td>
                        <td className='w-24'>
                            <button className="btn btn-primary btn-xs md:btn-sm">Set</button>
                        </td>
                    </tr>
                    {/* --------------------------------------------------------------------------------------- */}

                </tbody>
            </table>}
        </div>
    );
};

export default ActiveBalance;